import { type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  type FetchingItemsState,
  createFetchingItemsSlice,
} from "features/Application/slices/createFetchingItemsSlice";
import { type CustomerView } from "../types/models";

export interface TemplateCustomersState extends FetchingItemsState<CustomerView> {
  selectedIds: number[];
}

export const initialState: TemplateCustomersState = {
  isLoading: false,
  items: [],
  itemsCount: 0,
  selectedIds: [],
};

const slice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    entity: ReducerEntityPrefixTypes.TemplateGroups,
    name: "Customers",
    namespace: ReducerNamespaceTypes.People,
  },
  reducers: {
    setSelectedIds: (state, action: PayloadAction<number[]>) => {
      state.selectedIds = action.payload;
    },
  },
});

export const { fetchBegin, fetchFailure, fetchSuccess, reset, setSelectedIds } = slice.actions;

export default slice.reducer;
